module.exports = __webpack_public_path__ + "static/media/DSCF6262-3.dd7cb9e4.jpg";